import React from "react";
import { formatDate, typeNameOrder } from "../../utils/Utils";

const TradeHistoryTab = ((props)=>{
    const {trades,deal}=props
    const tradeItems = trades.map((item, index) => {
        const isLong = deal.strategy == "Long";
        return (
             <tr key={index}>
             <td className="date-data">{formatDate(item.status === "ongoing" ?item.created_at:item.time, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss")}</td>
             <td>
               <div className="side-data">
                 <h6 >{item.side}</h6>
               </div>
             </td>
             <td>
               <div className="order-type-data"> 
                 <h6>{typeNameOrder(item.name)}</h6>
               </div>
             </td>
             <td>
               <div className="order-type-data"> 
                 <h6>{item.status.toUpperCase()}</h6>
               </div>
             </td>
             <td>
               <div className="amount-data">
                 <h6>{item.status === "ongoing" ? item.quantity : item.filled}{" "}
                {deal.quote_name}</h6>
               </div>
             </td>
             <td>
               <div className="price-data">
                 <h6>{item.status === "ongoing" ? item.price : item.average}{" "}
                {deal.base_name}</h6>
               </div>
             </td>
             <td>
               <div className="totalValue-data">
                 <h6> {(item.quantity * item.price).toFixed(4)} {deal.base_name}</h6>
               </div>
             </td>
           </tr>
        );
    });
    return (
        <>
        {tradeItems}
        </>
        
    )
})

export default TradeHistoryTab;